import { JobTitle } from '@aw/prypco/enums';

export const maxFileUploadSize = 20_000_000; // 20MB

export const BUSINESS_UNIT = {
  Blocks: 'blocks',
};

export const blocksBackOfficeRoles: Array<JobTitle> = [
  JobTitle.BlocksComplianceOfficer,
  JobTitle.BlocksSysAdmin,
  JobTitle.BlocksOperationsAgent,
  JobTitle.BlocksFinanceAgent,
  JobTitle.BlocksTelecaller,
  JobTitle.BlocksRelationshipManager,
];

export const redirectBusinessUnitStorageKey = 'prypco-redirect-business-unit';
